import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { AzureSearchDataset } from 'app/model/dataset/azure-search.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSearchDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                indexName: '*'
            }
        }
    }
})
export class AzureSearchDatasetAdapter extends TabularTypeDatasetAdapter<AzureSearchDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureSearchDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureSearchDataset).name, 'indexName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureSearchDataset): Promise<AzureSearchDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, AzureSearchDataset.MODEL, 'indexName');
    }
}
